import { MessageCircle, Phone } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "../data/menuData";

export default function FinalCTA() {
  return (
    <section
      id="cta"
      data-testid="final-cta-section"
      className="relative bg-[#D92525] border-b-2 border-black overflow-hidden"
    >
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="absolute -top-12 -left-12 font-display text-[200px] text-black select-none">
          KKFC
        </div>
        <div className="absolute -bottom-16 -right-8 font-display text-[200px] text-black select-none">
          KKFC
        </div>
      </div>

      <div className="relative mx-auto max-w-7xl px-5 md:px-10 lg:px-16 py-16 md:py-24 text-center">
        <div className="inline-block brutal-border bg-[#FFB800] text-black px-3 py-1 text-xs font-bold uppercase tracking-widest mb-5">
          Don't Miss Out!
        </div>
        <h2 className="font-display text-5xl md:text-7xl lg:text-[96px] uppercase leading-[0.92] text-white max-w-5xl mx-auto">
          Order now on WhatsApp <br />
          and enjoy <span className="bg-[#FFB800] text-black px-2 inline-block">hot & fresh</span>{" "}
          chicken at your place!
        </h2>
        <p className="mt-6 font-body text-lg md:text-xl text-white/90 max-w-2xl mx-auto">
          Just one tap — hot and fresh KKFC chicken delivered to your doorstep.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={WA_LINK}
            target="_blank"
            rel="noreferrer"
            data-testid="finalcta-whatsapp-btn"
            className="inline-flex items-center justify-center gap-3 brutal-border brutal-shadow-lg bg-[#25D366] text-black font-bold px-8 py-4 text-base md:text-lg uppercase tracking-wide"
          >
            <MessageCircle size={22} strokeWidth={2.5} />
            Order on WhatsApp
          </a>
          <a
            href={`tel:${PHONE_TEL}`}
            data-testid="finalcta-call-btn"
            className="inline-flex items-center justify-center gap-3 brutal-border brutal-shadow-lg bg-black text-[#FFB800] font-bold px-8 py-4 text-base md:text-lg uppercase tracking-wide"
          >
            <Phone size={22} strokeWidth={2.5} />
            Call to Order
          </a>
        </div>
      </div>
    </section>
  );
}
